export enum StreetOrientation {
  UNDEFINED,
  FRONT,
  RIGHT,
  LEFT,
  BACK,
}

export enum StreetOrientationPreference {
  UNDEFINED = StreetOrientation.UNDEFINED,
  FRONT = StreetOrientation.FRONT,
  RIGHT = StreetOrientation.RIGHT,
  LEFT = StreetOrientation.LEFT,
  BACK = StreetOrientation.BACK,
  ANY = 5, // will be overidden by any specific street orientations
  ALL = 6,
}
